export type DiffLine = { kind: 'context' | 'add' | 'remove'; text: string };

export function unifiedDiff(before: string, after: string): DiffLine[] {
  const a = before.split('\n');
  const b = after.split('\n');
  const out: DiffLine[] = [];
  let i = 0;
  let j = 0;
  while (i < a.length || j < b.length) {
    const ai = a[i];
    const bj = b[j];
    if (ai === bj) {
      if (ai !== undefined) out.push({ kind: 'context', text: ai });
      i++;
      j++;
    } else {
      if (i < a.length) out.push({ kind: 'remove', text: ai ?? '' });
      if (j < b.length) out.push({ kind: 'add', text: bj ?? '' });
      i++;
      j++;
    }
  }
  return out;
}
